exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--tooltip__jKjvz{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:20px;height:20px;padding-left:1px;font-size:13px;line-height:15px;font-weight:700;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:50%}\n", ""]);

// exports
exports.locals = {
	"tooltip": "styles--tooltip__jKjvz"
};